export default (store) => store ? store.getters.getUser : {};
